import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::set
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:21
* @route '/motels/{motel}/owner'
*/
export const set = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: set.url(args, options),
    method: 'put',
})

set.definition = {
    methods: ["put"],
    url: '/motels/{motel}/owner',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::set
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:21
* @route '/motels/{motel}/owner'
*/
set.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return set.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::set
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:21
* @route '/motels/{motel}/owner'
*/
set.put = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: set.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::set
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:21
* @route '/motels/{motel}/owner'
*/
const setForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: set.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::set
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:21
* @route '/motels/{motel}/owner'
*/
setForm.put = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: set.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

set.form = setForm

const owner = {
    set: Object.assign(set, set),
}

export default owner